import { BalanceEntity } from '@app/domain/models/balance-entity.model';
import { SpeiAssignedEntry } from '@app/domain/models/spei/spei-assigned-entry.model';

/**
 * Fija el contexto SPEI de la sesión al elegir en `/products` (feature 152).
 * Puerto chico a propósito (ISP): la pantalla solo necesita estas dos
 * operaciones, no `AvailableAmountService` ni el storage cifrado.
 *
 * Las dos escriben EXACTAMENTE las llaves y el formato que ya escriben hoy
 * `selectProvider` y el `company-selector`: ninguna llave nueva.
 */
export abstract class SpeiContextActivator {
  /** Entrar por la cuenta padre ("Omitir", R34): lo que hacía `selectProvider`. */
  abstract activateFather(father: BalanceEntity): void;

  /** Entrar por una empresa de esa cuenta padre (R33): como el `company-selector`. */
  abstract activateCompany(father: BalanceEntity, company: BalanceEntity): void;

  /**
   * Entrar por una entidad ASIGNADA de un riel SIN cuenta padre (products_spei_sin_cuenta_padre
   * R20): fija el contexto de SU nivel. NO escribe, pisa ni borra `selectedFatherAccount`
   * ni `father_accounts_list`: esa sesión no tiene cuenta padre y no se inventa una.
   */
  abstract activateAssignedEntity(entry: SpeiAssignedEntry): void;
}
